import styled from "styled-components/macro"
import theme from "theme"
import { P } from "styledComponents/Typography"

export const CountryWrap = styled(P)`
  border-bottom: 1px solid ${theme.color.border};
  cursor: pointer;
`
